/*
 * @Author: Tina Huang
 * @Date: 2024-01-17 09:03:52
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-17 09:18:31
 * @Description: 
 */

const vips = [
  {
    code: 'admin',
    phone: 'htt0728'
  }
];

export default function checkVipUser(code, phone) {
  if(!code || !phone) return null;
  const _user = vips.find(item => item.code === code && item.phone === phone)
  if(_user) {
    localStorage.user = window.btoa(JSON.stringify(_user))
    return {
      type: 'success',
      msg: '🎉 绑定成功'}
  }
  return {
    type: 'error',
    msg: '💔 绑定失败，请确保你的信息正确无误'}
}